import React, { useEffect, useState } from 'react'
import ConfirmModal from '../ConfirmModal'
import PlaceModal from '../PlaceModal'

import './index.css'

export default function ConfigModal({ place, modal }) {
  const [modalType, setModalType] = useState('')

  useEffect(() => {
    setModalType(modal)
  }, [modal])

  function renderModal() {
    switch (modalType) {
      case 'edit':
        return <PlaceModal place={place} />
      case 'delete':
        return <ConfirmModal place={place} />
      default:
        break;
    }
  }

  return (
    <div>
      {renderModal()}
    </div>
  )
}